import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiCloud, FiTwitter, FiSearch, FiUser } from "react-icons/fi";
import { useCookies } from "react-cookie";
import axios from "axios";

import icon from "../assets/icon-rounded.png";

import "./css/header.css";

export default function HeaderSearchBar() {

    const [ bookName, setBookName ] = useState("");

    const [cookies, setCookie, removeCookie] = useCookies(["userPuuId"]);

    var userId = cookies.userPuuId;

    function typingBook(key) {
        setBookName(key.target.value);
    }

    function searchBookByHeader(event) {

        event.preventDefault();

        var typedBook = document.getElementById("headerBarSearchInput").value;
        window.location.href = `/procurar/livros/paid/${typedBook}`
    }

    useEffect(() => {
        if(userId) {
            axios.get(`https://cloudify-backend.herokuapp.com/users/get/byid/${userId}`)
            .then(resp => {
                console.log(resp.data)
                document.getElementById("userButtonImage").href = `/users/${resp.data.userInfo.userId}`;

                document.getElementById("userImage").src = resp.data.userInfo.profilePicture;

                document.getElementById("userIcon").hidden = true;
                document.getElementById("userButton").hidden = true;
                document.getElementById("userImage").hidden = false;
            })
        }
        else return false;
    }, []);

    return (
        <div className="bar" id="searchBarHandler">
            <Link to="/">
                <div id="titleContainer">
                    {/* <FiCloud style={{"fontSize":"24px", "color":"white"}}/> */}
                    <img src={icon} style={{height:"24px", width:"24px"}} />
                    <h2 id="cloudTitle" style={{"marginLeft":"4px"}}>Bookshelter</h2>
                </div>
            </Link>

            <div id="barSearchDiv">

                <form onSubmit={searchBookByHeader}>

                    <input id="headerBarSearchInput" onChange={typingBook} value={bookName} ></input>

                </form>

                <FiSearch id="searchButton" onClick={searchBookByHeader} />
            </div>

            <div id="secondInfo">
                <FiTwitter style={{"marginRight":"10px"}} />
                <a href="http://bibliotecas.cultura.gov.br/busca/##(global:(enabled:(space:!t),filterEntity:space))"> <h3>Encontre uma livraria</h3> </a>
                <a id="userButton" href="/login" > <FiUser id="userIcon" className="userButtonDefault"  /> </a>
                <a id="userButtonImage" > <img id="userImage" className="userButtonLogged" hidden /> </a>
            </div>
        </div>
    )
}